'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startBotTyping = undefined;

var _reduxActions = require('redux-actions');

var _typingIndicatorActionTypes = require('../constants/typingIndicatorActionTypes');

var startBotTyping = exports.startBotTyping = (0, _reduxActions.createAction)(_typingIndicatorActionTypes.START_BOT_TYPING, function (threadId, botId) {
  return { threadId: threadId, botId: botId };
});


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/startBotTyping.js
// module id = 596
// module chunks = 2 3